
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  /**
   * Converts JSON data to CSV and triggers a download in the browser.
   * Automatically adds BOM (Byte Order Mark) for Excel compatibility with Thai characters.
   * Applies formatting hacks to force Excel to treat IDs as text.
   */
  exportToCsv(data: any[], filename: string): void {
    console.log('[ExportService] Starting CSV export for', data.length, 'rows');

    if (!data || data.length === 0) {
      console.warn('[ExportService] No data to export');
      alert('ไม่พบข้อมูลสำหรับส่งออก (No Data to Export)');
      return;
    }

    try {
      const separator = ',';
      const keys = Object.keys(data[0]);
      
      // Build CSV content
      const csvContent = [
        // Header row (Always quote headers)
        keys.map(k => `"${k}"`).join(separator),
        
        // Data rows
        ...data.map(row => keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          
          // Convert to string
          let cellStr = String(cell);

          // EXCEL COMPATIBILITY FIX:
          // Prepend a tab character (\t) to specific columns to force Excel
          // to treat them as Text instead of Numbers.
          // This prevents:
          // 1. Citizen ID becoming scientific notation (e.g., 1.45E+12)
          // 2. Phone numbers losing leading zeros (e.g., 812345678)
          if (['Citizen ID', 'Phone', 'HN', 'Card UID'].includes(k)) {
              // Only apply if it looks like a number/code
              if (cellStr.length > 0) {
                  cellStr = `\t${cellStr}`;
              }
          }

          // Escape existing double quotes by doubling them
          cellStr = cellStr.replace(/"/g, '""');
          
          // Wrap every cell in quotes for safety
          return `"${cellStr}"`;
        }).join(separator))
      ].join('\n');

      // Add BOM for Excel compatibility (UTF-8)
      // This allows Excel to recognize Thai characters correctly
      const bom = '\uFEFF'; 
      const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
      
      // Create download link using modern API
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      link.style.display = 'none'; // Ensure it's not visible
      
      document.body.appendChild(link);
      
      // Programmatic click
      link.click();
      
      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        console.log('[ExportService] Download triggered successfully');
      }, 100);

    } catch (e) {
      console.error('[ExportService] Error generating CSV:', e);
      throw new Error('Failed to generate CSV file.');
    }
  }
}
